import { styled } from '@mui/system';

export const SignUpStepperHeaderContainer = styled('div')(({ theme }) => ({
  '& h2': {
    marginBottom: theme.spacing(1),
    textAlign: 'left'
  },
}));
